import '@abraham/reflection';
import './index.css';

import ReactDOM from 'react-dom/client';

import App from '@/v1/main/views/App';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <App />
);
